// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jb-0";
export var assigneeDetails = "_jb-1";
export var assigneeInfo = "_jb-2";
export var dropdownContainer = "_jb-4";
export var dropdownImage = "_jb-5";
export var editAssigneeInfo = "_jb-3";
export var editAssigneeModalContainer = "_jb-6";
export var hidden = "_jb-8";
export var input = "_jb-7";